import axios from "axios";
import { context } from "../context/authContext";
import { useContext } from "react";

const useApi = () => {
  const { token } = useContext(context);

  const url = process.env.REACT_APP_ENVIRONMENT === "local" ? "http://localhost:3000" : process.env.REACT_APP_API_URL;

  return {
    login: async (data) => {
      try {
        const response = await axios.post(`${url}/api/v1/login`, data);
        return response.data;
      } catch (error) {
        return error;
      }
    },
    logs: async () =>{
      try {
        const response = await axios.get(`${url}/api/v1/logs`, { headers: { Authorization: `Bearer ${token}` }});
        return response.data;
      } catch (error) {
        return error;
      }
    },
    syncContactos: () =>{
      return new Promise(async (res,rej) => {
        try {
          const response = await axios.get(`${url}/api/v1/integracion/contactos`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    syncPresupuestos: () =>{
      return new Promise(async (res,rej) => {
        try {
          const response = await axios.get(`${url}/api/v1/integracion/presupuestos`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    }

  };
};

export default useApi;
